// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5811":"085034b74331b901","5844":"7448ccbe39bbc373"}[chunkId] + ".js";
};